import type { Run } from "./types";
export function evaluationExecutionComplete(run: Pick<Run,"status"|"summary">): boolean {
 const status=run.status.toLowerCase();
 if (status==="completed"||status==="review_ready") return true;
 return status==="failed" && run.summary.total>0 && run.summary.remaining===0 && run.summary.success===run.summary.total;
}

/** Dashboard label is based on generation facts, never the Run's quality state. */
export function audioGenerationStatus(summary: {total:number;success:number;statuses?:Record<string,number>}): "已完成"|"失败"|"未知" {
 if(!summary.statuses || summary.total<=0)return "未知";
 if((summary.statuses.definitive_failed??0)>0)return "失败";
 if((summary.statuses.ambiguous_billed??0)>0)return "未知";
 return summary.success===summary.total ? "已完成" : "未知";
}
